(() => {
  if (!document.querySelector('#cart')) return;
  const root = window.Shopify?.routes?.root || '/';
  let pending;

  function summary(cart) {
    return ['#cartAsideSubtotalPrice', '#cartAsideTotalPrice', '.cartBodyItemContentTotalPriceActual']
      .map(selector => Array.from(cart.querySelectorAll(selector), el => el.textContent.trim()).join('|')).join('|');
  }

  function refreshCart() {
    if (pending) return pending;
    const cart = document.querySelector('#cart');
    const section = cart?.closest('[id^="shopify-section-"]');
    if (!section) return Promise.resolve(false);
    const sectionId = section.id.replace('shopify-section-', '');
    const previous = summary(cart);
    cart.setAttribute('aria-busy', 'true');
    const checkout = cart.querySelector('#cartAsideCheckout');
    if (checkout) checkout.disabled = true;
    const controller = new AbortController();
    const timeout = setTimeout(() => controller.abort(), 8000);
    // Ask Shopify to recalculate and render the existing cart. Do not replay old
    // quantities, properties or discount codes from a potentially stale page.
    pending = fetch(root + 'cart/update.js', {
      method: 'POST', credentials: 'same-origin',
      headers: {'Content-Type': 'application/json', 'Accept': 'application/json'},
      body: JSON.stringify({updates: {}, sections: [sectionId], sections_url: location.pathname}),
      signal: controller.signal
    }).then(response => {
      if (!response.ok) throw new Error('Cart refresh failed');
      return response.json();
    }).then(data => {
      const html = data.sections?.[sectionId];
      if (!html) throw new Error('Cart section unavailable');
      const next = new DOMParser().parseFromString(html, 'text/html').querySelector('#cart');
      if (!next) throw new Error('Cart markup unavailable');
      const changed = previous !== summary(next);
      // Keep any existing modal listeners when the shipping notice still applies.
      const existingNotice = cart.querySelector('#shippingNotice');
      const refreshedNotice = next.querySelector('#shippingNotice');
      if (existingNotice && refreshedNotice) refreshedNotice.replaceWith(existingNotice);
      cart.replaceWith(next);
      if (changed) {
        const notice = next.querySelector('#cartAsideNotice');
        if (notice) {
          notice.textContent = 'Your bag has been updated with current prices. Please review your total before checkout.';
          notice.setAttribute('role', 'status');
        }
      }
      return changed;
    }).catch(() => false).finally(() => {
      clearTimeout(timeout);
      document.querySelector('#cart')?.removeAttribute('aria-busy');
      const button = document.querySelector('#cartAsideCheckout');
      if (button) button.disabled = false;
      pending = null;
    });
    return pending;
  }

  // Delegation survives the refreshed cart markup.
  document.addEventListener('click', async event => {
    const target = event.target.closest?.('#cartAsideCheckout, #cartAsideBnpl');
    if (!target) return;
    event.preventDefault();
    if (target.id === 'cartAsideBnpl') {
      const modal = document.querySelector('.bnpl');
      if (modal) openModal(modal);
      return;
    }
    if (await refreshCart()) return;
    if (!document.querySelector('#cartAsideCheckout')) return;
    const notice = document.querySelector('#shippingNotice');
    if (notice) openModal(notice);
    else window.location.assign(root + 'checkout');
  });
  refreshCart();
  window.addEventListener('pageshow', event => {if (event.persisted) refreshCart();});
})();
